module.exports = "<div class=\"task-widget\">\n  <div class=\"table-cell full-width\" *ngFor=\"let task of tasks\">\n    <div class=\"common-panel\" *ngIf=\"task.values.length == 0\">\n      <h4>No tasks.</h4>\n    </div>\n    <div class=\"task-repeat\" *ngFor=\"let value of task.values\">\n      <task-details [hideClient]=\"false\" [taskDetails]=\"value\" (updatedTaskDetails)=\"onTaskDetailsChange($event)\"></task-details>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/task/taskwidget/task-widget.component.html
// module id = 2354
// module chunks = 0